let $ = require('jquery'),
  ga = require('../../vendor/google-analytics'),
  dialog = require('jquery-ui/ui/widgets/dialog'),
  validate = require('jquery-validation');

let Core = (function() {
  let priv = {},
    pub = {};

  priv.$mainNav             = $('.main-nav');
  priv.$mobileNavTrigger    = $('.main-nav-hamburger-wrapper');
  priv.$subFooterLinkToTop  = $('.sub-footer-back-to-top').find('a');

  /**
   * Handles the click of the menu icon
   */
  priv.toggleMobileNav = function () {
    $(this).toggleClass('active');
    priv.$mainNav.toggleClass('active');
  };

  priv.backToTop = function backToTop(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 250);
  };

  /**
   * Attach the event handlers
   */
  priv.attachHandlers = function () {
    priv.$mobileNavTrigger.on('click', priv.toggleMobileNav);
    priv.$subFooterLinkToTop.on('click', priv.backToTop);
    $('.dialog-trigger').on('click', priv.openDialog);
    $('.dialog-close').on('click', priv.closeDialog);
  };

  /**
   * Does handling of AJAX form submissions.
   *
   * @param Event e
   */
  priv.onAjaxFormSubmit = function(e) {
    var $this = $(this);

    if ($this.valid()) {

      // Don't let them submit more than once.
      var $submitBtn = $this.find('.submit');

      $submitBtn.attr('disabled', 'disabled');

      // Generate the data for the email ajax request
      var contactData = $this.serializeArray().reduce(function (obj, item) {
        obj[item.name] = item.value;
        return obj;
      }, {});

      /*
      // Make the email request  fire and forget and send an error on the server side
      // if something happens so we can give feedback right away.
      $.ajax({
        type: 'POST',
        url: '/handleContactSubmission',
        dataType: 'json',
        data: {
          form: contactData
        }
      });*/

      let responseMsg = 'Thanks for the submission.';

      // Submit contact form
      $.ajax({
        type: 'POST',
        url: '/handleContactSubmission',
        dataType: 'json',
        data: {
          form: contactData
        },
        success: function(result) {
          $this.html('' +
            '<div class="contact-form-submit-message row"><div class="columns"> ' +
            '<strong>' + result.message + '</strong>' +
            '</div></div>');
        },
        error: function(resp) {
          let response = resp.responseJSON;
          let errors = response.errors;
          let message = "<strong>" + response.message + "</strong>" + "<br/><ul>" +
            errors.map(function(error) {
              return "<li>" + Object.keys(error).map(function(key) {
                return error[key];
              }) + "</li>";
            }).join("") + "</ul><br/>";
          $this.find("#contact-form-errors").html(message);
          $this.find("#contact-form-errors").scrollTop();
        }
      });

      // Individual forms need to handle success
      $this.trigger('formsent');

      $submitBtn.removeAttr('disabled');
    }

    e.preventDefault();
  };

  /**
   * Dialog open method
   */
  priv.openDialog = function(e) {
    e.preventDefault();
    var targetDialog = $(e.target).attr('data-dialog');

    if (typeof targetDialog !== 'undefined') {
      pub.modal('#' + targetDialog);
    }
  };

  /**
   * Dialog close method
   *
   * @param {Event} e
   */
  priv.closeDialog = function(e) {
    e.preventDefault();

    $(e.target).closest('.ui-dialog-content').dialog('close');
  };

  // Public methods

  /**
   * Makes a modal
   *
   * @param {String} selector
   */
  pub.modal = function(selector) {
    $(selector).dialog({
      draggable: false,
      width: 760,
      modal: true,
      closeText: '',
      classes: {
        'ui-dialog': selector.substr(1) + '-dialog transparent-titlebar',
      }
    });
  };

  // Initialization

  // Get any AJAX forms that need to be handled.
  priv.$ajaxForms = $('body').find('.ajax-form');

  $(priv.$ajaxForms).each(function(i, el) {
    $(el).validate();
    $(el).submit(priv.onAjaxFormSubmit);
  });

  priv.attachHandlers();

  ga('send', 'pageview');

  return pub;
})();

module.exports = Core;



// WEBPACK FOOTER //
// ./htdocs/content/themes/tpt-national/assets/js/modules/Core/Core.js